import { FaceDetector, FilesetResolver } from '@mediapipe/tasks-vision';
import { FACE_DETECTION } from '../config';

export async function createFaceDetector() {
  const vision = await FilesetResolver.forVisionTasks(
    FACE_DETECTION.WASM_BASE_URL
  );

  return FaceDetector.createFromOptions(vision, {
    baseOptions: {
      modelAssetPath: FACE_DETECTION.MODEL_URL,
      delegate: 'CPU',
    },
    runningMode: 'VIDEO',
    minDetectionConfidence: FACE_DETECTION.MIN_CONFIDENCE,
  });
}

export function evaluateFaceFrame({ detections, videoWidth, videoHeight }) {
  if (!videoWidth || !videoHeight) return { state: 'not-ready' };
  if (!detections?.length) return { state: 'no-face' };
  if (detections.length > 1) return { state: 'multiple-faces' };

  const box = detections[0]?.boundingBox;
  if (!box) return { state: 'no-face' };

  const centerX = (box.originX + box.width / 2) / videoWidth;
  const centerY = (box.originY + box.height / 2) / videoHeight;
  const widthRatio = box.width / videoWidth;
  const heightRatio = box.height / videoHeight;
  const isLargeEnough = widthRatio >= 0.18 && heightRatio >= 0.24;
  const isCentered =
    centerX >= 0.3 && centerX <= 0.7 && centerY >= 0.25 && centerY <= 0.65;

  if (!isLargeEnough) return { state: 'too-far' };
  if (!isCentered) return { state: 'off-center' };

  return { state: 'ready', boundingBox: box };
}
